module.exports = __webpack_public_path__ + "static/media/summer-school.a662f53d.png";